<div class="preloader" *ngIf="isSpinnerVisible">
  <cnect-loader-link [size]="'md'" [color]="'e11-bg-skin-primary-accent'"></cnect-loader-link>
</div>
